// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'reportconfigs'"
        editRoute="reportConfigEdit"
        :filter="filters"
        :headers="headers"
        id="_id"
        name="Map"
        permissions="reportconfigs"
        :searchBarText="searchBarText"
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import ItemList from '@sdgsystems/vue-common/components/ItemList.vue'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true
        },
        {
          text: 'Type',
          value: 'type',
          sortable: true
        },
        {
          name: 'Zone',
          value: 'zones',
          sortable: true
        },
        {
          text: 'Email',
          value: 'email',
          type: 'checkbox',
          sortable: true
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'filters'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ReportConfigs.vue